/* eslint-disable no-extra-boolean-cast */
import { h } from 'preact';
import StaticContainer from '../../components/StaticContainer/StaticContainer';
import EmptyBg from '../EmptyBg';
import { getParamsFromURL, getBrokerDisplayNameFromURL } from '../../utils/brokerUtils';
import { sendPostMessage } from '../../utils/browserUtils';
import postMessageTypes from '../../constants/messageTypes';
import { brokerRegex, distributorRegex, smallcaseRegex } from '../../utils/copyConstants';


import styles from './OrderCancelled.css';

function handleClick(error) {
  if (!!error) {
    sendPostMessage({
      messageType: postMessageTypes.USER_CANCELLED,
    });
    return;
  }
  sendPostMessage({
    messageType: postMessageTypes.RESTART_ORDER,
  });
}

function OrderCancelled(props) {
  if (props.loading) {
    return (<EmptyBg />);
  }
  const params = getParamsFromURL();
  const brokerName = getBrokerDisplayNameFromURL(props.brokerMap);
  const {
    error,
    smallcase,
    distributor = 'merchant',
  } = params;

  const copy = props.copies['order-cancelled'];
  return (
    <StaticContainer showClose={true}>
      <div class="route-padding">
        <div class="route-main-container">
          <div class={styles['top-logo']}>
            <i class="icon-error" />
          </div>
          <h2 class="title">
            {
              copy.title
                .replace(brokerRegex, brokerName)
                .replace(distributorRegex, distributor)
                .replace(smallcaseRegex, smallcase)
            }
          </h2>
          <div class={`${styles['desc']} lh-144 text-normal`}>
            {/* {`You have closed ${brokerName} platform and your order got cancelled.`} */}
            {
              !!error ?
                copy
                  .withError
                  .replace(brokerRegex, brokerName)
                  .replace(distributorRegex, distributor)
                  .replace(smallcaseRegex, smallcase) :
                copy
                  .withoutError
                  .replace(brokerRegex, brokerName)
                  .replace(distributorRegex, distributor)
                  .replace(smallcaseRegex, smallcase)
            }
          </div>
          <button
            type="button"
            class={`btn ${styles['mt16']} ${styles['retry']}`}
            onClick={() => handleClick(error)}
          >
            {
              !!error ?
                'Go Back' :
                'Retry Order'
            }
          </button>
        </div>
      </div>
    </StaticContainer>
  );
}

export default OrderCancelled;



// WEBPACK FOOTER //
// ./routes/OrderCancelled/OrderCancelled.js